import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCall } from './api-calls/apicalls.service';
import { HeadersService } from './api-calls/headers.service';

@Injectable({
    providedIn: 'root',
})
export class MeetingService extends HeadersService {
    constructor(public _http: HttpClient) {
        super(_http);
    }

    getMeeting(date: string) {
        const url = getCall('meeting', null, {
            access: localStorage.getItem('user-access'),
            date: date,
        });

        return this._http.get(url, this.getHeaders());
    }

    getMeetingList(date: string) {
        const url = getCall('meetingList', null, {
            access: localStorage.getItem('user-access'),
            date: date,
        });

        return this._http.get(url, this.getHeaders());
    }

    postMeeting(data: any, update: boolean = false) {
        const url = getCall('meeting-actions', null, {
            access: localStorage.getItem('user-access'),
        });

        return update
            ? this._http.put(url, data, this.getHeaders())
            : this._http.post(url, data, this.getHeaders());
    }
}
